import { MGPValidation, MGPOptional, Utils } from '@everyboard/lib';
import { RulesConfigDescriptions } from '../../config/RulesConfigDescriptions';
import { GameNode } from '../../jscaip/AI/GameNode';
import { CoordFailure } from '../../jscaip/Coord';
import { GameStatus } from '../../jscaip/GameStatus';
import { NInARowHelper } from '../../jscaip/NInARowHelper';
import { PlayerOrNone } from '../../jscaip/Player';
import { ConfigurableRules } from '../../jscaip/Rules';
import { RulesFailure } from '../../jscaip/RulesFailure';
import { TableUtils } from '../../jscaip/TableUtils';
import { ConnectSixDrops, ConnectSixFirstMove } from './ConnectSixMove';
import { ConnectSixState } from './ConnectSixState';
export class ConnectSixNode extends GameNode {
}
export class ConnectSixRules extends ConfigurableRules {
    static singleton = MGPOptional.empty();
    static RULES_CONFIG_DESCRIPTION = RulesConfigDescriptions.GOBAN;
    static get() {
        if (ConnectSixRules.singleton.isAbsent()) {
            ConnectSixRules.singleton = MGPOptional.of(new ConnectSixRules());
        }
        return ConnectSixRules.singleton.get();
    }
    static CONNECT_SIX_HELPER = new NInARowHelper(Utils.identity, 6);
    static getVictoriousCoords(state) {
        return ConnectSixRules.CONNECT_SIX_HELPER.getVictoriousCoord(state);
    }
    getRulesConfigDescription() {
        return ConnectSixRules.RULES_CONFIG_DESCRIPTION;
    }
    getInitialState(config) {
        const board = TableUtils.create(config.width, config.height, PlayerOrNone.NONE);
        return new ConnectSixState(board, 0);
    }
    applyLegalMove(move, state, _config, _info) {
        if (move instanceof ConnectSixDrops) {
            return this.applyLegalDrops(move, state);
        }
        else {
            return this.applyLegalFirstMove(move, state);
        }
    }
    applyLegalDrops(move, state) {
        const player = state.getCurrentPlayer();
        const first = move.getFirst();
        const second = move.getSecond();
        const newBoard = state.getCopiedBoard();
        newBoard[first.y][first.x] = player;
        newBoard[second.y][second.x] = player;
        return new ConnectSixState(newBoard, state.turn + 1);
    }
    applyLegalFirstMove(move, state) {
        const player = state.getCurrentPlayer();
        const newBoard = state.getCopiedBoard();
        newBoard[move.coord.y][move.coord.x] = player;
        return new ConnectSixState(newBoard, state.turn + 1);
    }
    isLegal(move, state) {
        if (move instanceof ConnectSixFirstMove) {
            Utils.assert(state.turn === 0, 'ConnectSixFirstMove should only be used at first move');
            if (state.isNotOnBoard(move.coord)) {
                return MGPValidation.failure(CoordFailure.OUT_OF_RANGE(move.coord));
            }
            return MGPValidation.SUCCESS;
        }
        else {
            Utils.assert(state.turn > 0, 'ConnectSixDrops should only be used after first move');
            if (state.isNotOnBoard(move.getFirst())) {
                return MGPValidation.failure(CoordFailure.OUT_OF_RANGE(move.getFirst()));
            }
            else if (state.isNotOnBoard(move.getSecond())) {
                return MGPValidation.failure(CoordFailure.OUT_OF_RANGE(move.getSecond()));
            }
            else {
                return this.isLegalDrops(move, state);
            }
        }
    }
    isLegalDrops(move, state) {
        if (state.getPieceAt(move.getFirst()).isPlayer()) {
            return MGPValidation.failure(RulesFailure.MUST_CLICK_ON_EMPTY_SQUARE());
        }
        else if (state.getPieceAt(move.getSecond()).isPlayer()) {
            return MGPValidation.failure(RulesFailure.MUST_CLICK_ON_EMPTY_SQUARE());
        }
        else {
            return MGPValidation.SUCCESS;
        }
    }
    getGameStatus(node) {
        const state = node.gameState;
        const victoriousCoord = ConnectSixRules.CONNECT_SIX_HELPER.getVictoriousCoord(state);
        if (victoriousCoord.length > 0) {
            return GameStatus.getVictory(state.getCurrentOpponent());
        }
        if (TableUtils.contains(state.board, PlayerOrNone.NONE)) {
            return GameStatus.ONGOING;
        }
        else {
            return GameStatus.DRAW;
        }
    }
}
